/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  dataRequest,
  selectRequestsStateById,
  selectItemById
} from 'mt-react-common/common/reducers/objectCollection/reducer';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

const faqContentCollectionRN = 'faqContents.collections.faqContentCollection';

class FagContentItemPopUp extends Component {
  constructor(props) {
    super(props);
    if (!this.props.selectItem) {
      this.props.dataRequest();
    }
  }

  render() {
    if (this.props.requestState.requestInProcess) {
      return (
        <div className="modal-dialog modal-gray" role="document">
          <div className="modal-content">
            <MediumPreLoader />
          </div>
        </div>
      );
    } else if (!this.props.selectItem) {
      return (
        <div
          className="modal-dialog modal-gray"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                className="close close-black"
                data-dismiss="modal"
                href=""
                onClick={this.props.handleClose}
              />
              <i className="fa fa-exclamation-circle modal-icon" />
            </div>
            <div className="modal-body">Контент {this.props.id} не найден.</div>
          </div>
        </div>
      );
    }
    return (
      <div
        className="modal-dialog modal-gray"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              className="close close-black"
              data-dismiss="modal"
              href=""
              onClick={this.props.handleClose}
            />
            <i className="fa fa-exclamation-circle modal-icon" />
            <h4 className="modal-title">{this.props.selectItem.title}</h4>
          </div>
          <div className="modal-body">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: this.props.selectItem.html
              }}
            />
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary btn-block"
              data-dismiss="modal"
              type="button"
              onClick={this.props.handleClose}
            >
              {t('Все понятно')}!
            </button>
          </div>
        </div>
      </div>
    );
  }
}

FagContentItemPopUp.defaultProps = {
  selectItem: null
};

FagContentItemPopUp.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,

  // CONNECT STATE
  selectItem: PropTypes.shape({
    title: PropTypes.string.isRequired,
    seoUrl: PropTypes.string.isRequired,
    html: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.shape),
    beforeContentSeoUrl: PropTypes.shape({
      title: PropTypes.string.isRequired,
      seoUrl: PropTypes.string.isRequired
    }),
    nextContentSeoUrl: PropTypes.shape({
      title: PropTypes.string.isRequired,
      seoUrl: PropTypes.string.isRequired
    }),
    parent: PropTypes.shape({
      title: PropTypes.string.isRequired,
      seoUrl: PropTypes.string.isRequired
    })
  }),
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT DISPATCH
  dataRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectItem: selectItemById(state, faqContentCollectionRN, props.id),
  requestState: selectRequestsStateById(state, faqContentCollectionRN, props.id)
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequest: () => dispatch(dataRequest(faqContentCollectionRN, props.id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FagContentItemPopUp);



// WEBPACK FOOTER //
// ./src/components/FaqContents/FagContentItemPopUp/FagContentItemPopUp.js